import classNames from 'classnames';
import * as React from 'react';
import {useSiteSettings} from '../../../containers/DataContainer/siteSettings/withSiteSettings';
import {withoutSize} from '../../../services/env/siteSettings/fonts/fonts';
import styles from './Title.scss';
import {IInner} from './Title.types';

export const TitleComponent: React.FunctionComponent<IInner> = ({id, children, className, role}) => {
  const siteSettings = useSiteSettings();
  const titleStyle = withoutSize(siteSettings.fonts.trackTitleFont || siteSettings.fonts.title);

  return (
    <h3
      className={classNames([styles.title, className])}
      id={id}
      style={titleStyle}
      data-hook="title-header"
      role={role}
      title={children}
    >
      {children}
    </h3>
  );
};

TitleComponent.displayName = 'Title';
